import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {Card, CardBody} from "reactstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import { Button,Modal,ModalHeader } from 'reactstrap';
import {ToastContainer,toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Table from 'react-bootstrap/Table';
import Axios from 'axios'
import { select } from "redux-saga/effects";
import { v4 as uuidv4 } from 'uuid';
import axios from "axios";
import { useTable } from "react-table";

export default function Getcover() {
    const [clients, setClients] = useState([])
    const [products,setProducts] = useState([])
    const [client, setClient] = useState('')
    const [productName, setProductname] = useState("")
    const [productCode, setProductcode] = useState("")
    const [coverOptions, setCoveroptions] = useState([])
    const [coverOptioncode, setCoveroptioncode] = useState('');
    const [insuredItems, setInsureditems] = useState([])
    const [selectedItem, setSelecteditem] = useState('')
    const [coverOptionname, setCoveroptionname] = useState('');
    const [coverOption, setCoveroption] = useState(null);
    const [capacity, setCapacity] = useState(0)
    const [sumInsured, setSuminsured] = useState(0)
    const [coverPeriod, setCoverperiod] = useState('')
    const [quoteText, setQuotetext] = useState('GET QUOTATION')
    const [step, setStep] = useState(1)
    const [premium, setPremium] = useState(null)
    const [stampduty, setStampduty] = useState(40);
    const [PHCF, setPHCF] = useState(null)
    const [trainingLevy, setTraininglevy] = useState(null)
    const [basicPremium, setBasicpremium] = useState(0)
    const [modal, setModal] = useState(false)
    const [modal2, setModal2] = useState(false)
    const [modal6, setModal6] = useState(false)
    const [reg,setReg] = useState('');
    const [makes, setMakes] = useState([]);
    const [makeCode, setMakecode] = useState('')
    const [makeName, setMakename] = useState('')
    const [modelCode, setModelcode] = useState('');
    const [modelName, setModelname] = useState('')
    const [models, setModels] = useState([]);
    const [chassis, setChassis] = useState('');
    const [engineNumber, setEnginenumber] = useState('');
    const [cc, setCC] = useState('');
    const [color, setColor] = useState('');
    const [tonnage, setTonnage] = useState(0);
    const [yom, setYom] = useState('')
    const [agent, setAgent] = useState("");
    const [firstName, setFirstname] = useState("")
    const [lastName, setLastname] = useState("");
    const [otherNames, setOthernames] = useState("");
    const [phone, setPhone] = useState("");
    const [email, setEmail] = useState("");
    const [idNumber, setIDNumber] = useState("");
    const [pin, setPin] = useState("");
    const [submitText, setSubmittext] = useState('SUBMIT')
    const [commencement, setCommencement] = useState('');
    const [commencementDate, setCommencementDate] = useState('')
    const [commencementUnix, setCommencementunix] = useState(null)
    const [expiryUnix, setExpiryunix] = useState(null)
    const [expiry, setExpiry] = useState('');
    const [expiryDate, setExpirydate] = useState('')
    const [searchTerm, setSearchTerm] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const [searchTerm2, setSearchTerm2] = useState('');
    const [suggestions2, setSuggestions2] = useState([]);
    const [searchTerm3, setSearchTerm3] = useState('');
    const [suggestions3, setSuggestions3] = useState([]);
    const [selectedClient, setSelectedClient] = useState(null);
    const [doubleInsurancestatusLoading, setDoubleinsuranceloading] = useState(false)
    const [doubleInsurancestatus, setDoubleinsurancestatus] = useState(null)
    const [doubleinsuranceMessage, setDoubleinsuracemessage] = useState('')
    const [checking, setChecking] = useState(1);
    const [selectedOption, setSelectedOption] = useState('GROSS');
    const [payAmount, setPayamount] = useState(0);
    const [mpesaPhone, setMpesaphone] = useState('');
    const [prdCode, setPrdcode] = useState('');
    const [agentCode, setAgentcode] = useState('');
    const [coverDays, setCoverdays] = useState('')
    const [commission, setCommission] = useState('')
    const [netCommission, setNetcommission] = useState('');
    const [netPremium, setNetprememium] = useState('')
    const [commissionRate, setCommissionrate] = useState('');
    const [today, setToday] = useState(null)
    const [payTest, setPaytext] = useState('SEND REQUEST')
    const [resendText, setResendtext] = useState('RESEND REQUEST')
    const [iraCode, setIracode] = useState('')
    const [bodyCode, setBodycode] = useState('');
    const [bodyType, setBodytype] = useState('')
    const [clientEmail,setClientemail] = useState('')
    const [clientName, setClientname] = useState('')
    const [clientPhone, setClientphone] = useState('')
    const [clientPin, setClientpin] = useState('')
    const [iraNumber, setIranumber] = useState('')
    const [coverType, setCovertype] = useState('')
    const [policyNumber, setPolicynumber] = useState('')
    const [isCert, setIscert] = useState(0)
    const [certURL, setCertURL] = useState('')
    const [eMessage, setEmessage] = useState('')
    const [paymentMode, setPaymentMode] = useState(0);
    const [utilize, setUtilize] = useState(0);
    const [walletBallance, setWalletbalance] = useState(0);
    const [walletNo, setWalletno] = useState('')
    const [numberOfDays, setNumberOfDays] = useState(0);
    const [riskClass, setRiskclass] = useState('')
    const [availableCommission, setAvailablecommission] = useState(0)
    const [errorCode, setErrorcode] = useState('')
    const [errorMessage, setErrormessage] = useState('')
    const [isMpesa, setIsmpesa] = useState(true)
    const [comm2, setComm2] = useState(0)
    const [nc2, setNc2] = useState(0)
    const [file, setFile] = useState(null)
    const [poid, setPoid] = useState("")
    const [ex, setEx] = useState('Expiry Date')
    const [cm, setCm] = useState('')
    const [agentName,setAgentname] = useState('')
    const [file1, setFile1] = useState(null)
    const [file2, setFile2] = useState(null)
    const [file3, setFile3] = useState(null)
    const [folderID, setfolderID] = useState('')
    const [modal3, setModal3] = useState(false)
    const [mpesaCode, setMpesacode] = useState('')
    const [checkMpesa, setCheckmpesa] = useState(false)
    const [verifyText, setVerifytext] = useState('VERIFY')
    const [promptID, setPromptid] = useState(0)
    const [proposalOID, setProposalOID] = useState('')
    const [insuredOID, setInsuredOID] = useState('')
    const [branch, setBranch] = useState(null)
    const [insuredSchedule, setInsureschedule] = useState('')
    const [approved, setApproved] = useState(0)
    const [makePaymenttext, setMakepaymenttext] = useState('MAKE PAYMENT')
    const [Dealercode, setDealercode] = useState('')
    const [mpesaClicke, setMpesaclicked] = useState(false)
    const [retryText, setRetrytext] = useState('Retry')
    const [credentials, setCredentials] = useState(null)
    const [isAuth, setIsauth] = useState(false)
    const company = 'Definite'
    const [prompt, setPrompt] = useState(false)
    const [transactionId, setTransactionid] = useState(null)

    useEffect(()=>{
    const getCredentials =async()=>{
    const res = await fetch(`https://digitalapi.definiteassurance.com/api/getCredentials?username=${company}`)
    const data = await res.json();
    const {Username, Password} = data;
    const cred = btoa(`${Username}:${Password}`)
    setCredentials(btoa(`${Username}:${Password}`))
    setIsauth(true)


    }
    getCredentials()

    },[])
    
    const calculate =(e)=>{
        setProductcode(e.target.value)
        setModal6(!modal6)
    }

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
      };

      const handleFileChange1 = (e) => {
            setFile1(e.target.files[0]);
        };
        const handleFileChange2 = (e) => {
            setFile2(e.target.files[0]);
        };
        const handleFileChange3 = (e) => {
            setFile3(e.target.files[0]);
        };

      const handleUpload = async () => {
        if (!file) {
            toast.error('Select file to upload')
          return;
        }
        const formData = new FormData();
        formData.append('file', file);
        formData.append('agent', agentCode);
        formData.append('proposal', poid);
      
    
        const requestOptions = {
              method: 'POST',
              body: formData
            };
    
        try {
    
         
          const response = await axios.post('https://digitalapi.definiteassurance.com/api/uploadDocument', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
            withCredentials:'false'
          } 
          );
    
    
          if (response.data.success) {
             //pass
          } else {
            //pass
          }
        } catch (error) {
         //pass
        } finally {
           //pass
        }
      };


        const handleUpload1 = async (proposalOID) => {
      
          const folder = proposalOID
          const formData = new FormData();
          formData.append('file', file1);
          formData.append('agent', agentCode);
          formData.append('proposal', folder);

           const formData2 = new FormData();
          formData2.append('file', file2);
          formData2.append('agent', agentCode);
          formData2.append('proposal', folder);

          const formData3 = new FormData();
          formData3.append('file', file3);
          formData3.append('agent', agentCode);
          formData3.append('proposal', folder);
        
      
          const requestOptions = {
                method: 'POST',
                body: formData
              };
      
          try {
      
           
            const response = await axios.post('https://digitalapi.definiteassurance.com/api/uploadIdentity', formData, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
              withCredentials:'false'
            } 
            );

             const response2 = await axios.post('https://digitalapi.definiteassurance.com/api/uploadIRA', formData2, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
              withCredentials:'false'
            } 
            );

            const response3 = await axios.post('https://digitalapi.definiteassurance.com/api/uploadKRA', formData3, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
              withCredentials:'false'
            } 
            );           
          } catch (error) {
           //pass
          } finally {
             //pass
          }
        };

    useEffect(() => {
        // Function to get days in current month
        const getDaysInCurrentMonth = () => {
          const now = new Date();
          // Get last day of current month by going to month+1 and day 0
          return new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate();
        };
        
        const days = getDaysInCurrentMonth();
        setNumberOfDays(days);
      }, []);


    const handleChange = (e) => {
      setPaymentMode(e.target.checked ? 1 : 0);
    };

    const handleChange2 = (e) => {
        setUtilize(e.target.checked ? 1 : 0);
      };
  


    useEffect(()=>{

        if(coverOption == 1 || coverOption == 58 ){
            setCovertype(100)
        }
        else if(coverOption == 2){
            setCovertype(200)
        }

    },[coverOption])
    

    

    const handleOptionChange = (event) => {
      setSelectedOption(event.target.value);
    };

    const handleSearch = (e) => {
        const value = e.target.value;
        setSearchTerm(value);
        console.log(clients)
        if (value.length > 0) {
          const filtered = clients.filter(
            (client) =>
              client.FirstName.toLowerCase().includes(value.toLowerCase()) ||
              client.Surname.toLowerCase().includes(value.toLowerCase()) ||
               client.IdentificationNo.toLowerCase().includes(value.toLowerCase())
          );
          setSuggestions(filtered);
        } else {
          setSuggestions([]);
        }
      };

        const handleSearch2 = (e) => {
        const value = e.target.value;
        setSearchTerm2(value);
       
        if (value.length > 0) {
          const filtered = makes.filter(
            (make) =>
              make.Description.toLowerCase().includes(value.toLowerCase())
          );
          setSuggestions2(filtered);
        } else {
          setSuggestions2([]);
        }
      };

    const handleSearch3 = (e) => {
        const value = e.target.value;
        setSearchTerm3(value);
       
        if (value.length > 0) {
          const filtered = models.filter(
            (model) =>
              model.Description.toLowerCase().includes(value.toLowerCase())
          );
          setSuggestions3(filtered);
        } else {
          setSuggestions3([]);
        }
      };



      const handleSelect = (client) => {
        setSearchTerm(`${client.FirstName} ${client.Surname}`);
        setSelectedClient(client.OID);
        setSuggestions([]);
      };

    const handleSelect2 = (make) => {
        setSearchTerm2(`${make.Description} `);
        setMakecode(make.OID);
        setSuggestions2([]);
      };
    const handleSelect3 = (model) => {
        setSearchTerm3(`${model.Description} `);
        setModelcode(model.OID);
        setSuggestions3([]);
      };



    useEffect(()=>{

        const getClientid =async()=>{
            const res = await fetch(`https://digitalapi.definiteassurance.com/api/getClientid?client=${selectedClient}`,{
                method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
            });
            const data = await res.json();
            setClient(data.IdentificationNo)
        }

        const getClientdetails =async()=>{
            const res = await fetch(`https://digitalapi.definiteassurance.com/api/getClientdetails?client=${selectedClient}`,{
                 method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }

            })
            const data = await res.json();
            setClientemail(data.Email)
            setClientname(data.Dealer_name)
            setClientpin(data.Pin)
            setClientphone(data.Mobile)
        }

        

        if(selectedClient && isAuth){
            getClientid()
            getClientdetails()
        }

    },[selectedClient,isAuth])


    function formatDateFromMilliseconds(milliseconds) {
        const date = new Date(milliseconds);
        const day = String(date.getDate()).padStart(2, '0'); // Ensure 2 digits
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const year = date.getFullYear();
        
        
        return `${day}/${month}/${year}`;
    }

          useEffect(()=>{
            const now = new Date();
            
            // Format YYYY-MM-DD
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
            
            // Format HH:mm:ss.SSS
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            const seconds = String(now.getSeconds()).padStart(2, '0');
            const milliseconds = String(now.getMilliseconds()).padStart(3, '0');
            
           
    
            setToday(`${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}`)
    
          },[])
    const handleDateChange = (e) => {
        const dateTime = e.target.value;
        const millisecondsSinceEpoch = new Date(dateTime).getTime();
        setCommencement(millisecondsSinceEpoch);
        setCommencementDate(formatDateFromMilliseconds(millisecondsSinceEpoch))
        setCommencementunix(formatDate(millisecondsSinceEpoch))
        setCm(formatDate(millisecondsSinceEpoch))
        const dt = Date.now().toString()
        var monthDuration;

        if(numberOfDays == 30){
            monthDuration = 2592000000-86400000;
        }
        else if(numberOfDays == 31){
            monthDuration = 2592000000;
        }

        else if(numberOfDays == 28){
            monthDuration =  2419200000 -86400000 ;
        }

        else if(numberOfDays == 29){
            monthDuration =  2419200000 ;
        }
        const weekDuration = 604800000-86400000;
       
        const fortnightDuration = 1209600000-86400000;
        const annualDuration = 31536000000-86400000;

        if(coverPeriod == 'Monthly' || coverPeriod == '3Installments' || coverPeriod == '6Installments' || coverPeriod == '10Installments' || coverPeriod == '2installments'){
            const exp = millisecondsSinceEpoch+monthDuration;
            setExpiry(exp);
            setExpirydate(formatDateFromMilliseconds(exp))
            setExpiryunix(formatDate(exp))
            setEx(formatDate(exp))
            setCoverdays(30)
            
        }
        else if(coverPeriod == 'Week'){
            const exp = millisecondsSinceEpoch + weekDuration;
            setExpiry(exp);
            setExpirydate(formatDateFromMilliseconds(exp))
            setExpiryunix(formatDate(exp))
            setEx(formatDate(exp))
            setCoverdays(7)
        }
        else if(coverPeriod == 'Fortnight'){
            const exp = millisecondsSinceEpoch + fortnightDuration
            setExpiry(exp);
            setExpirydate(formatDateFromMilliseconds(exp))
            setExpiryunix(formatDate(exp))
             setEx(formatDate(exp))
            setCoverdays(14)
        }
        else if(coverPeriod == 'Annually'){
            const exp = millisecondsSinceEpoch + annualDuration
            setExpiry(exp);
            setExpirydate(formatDateFromMilliseconds(exp))
            setExpiryunix(formatDate(exp))
             setEx(formatDate(exp))
            setCoverdays(365)
        }
      };

      function formatDate(milliseconds) {
        const date = new Date(milliseconds);
        
        // Extract date components
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        const ms = String(date.getMilliseconds()).padStart(3, '0');
        
        // Format as YYYY-MM-DD HH:mm:ss.ms
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${ms}`;
    }
    function formatMillisecondsToDateTime(milliseconds) {
        const date = new Date(milliseconds);
        
        // Extract date components
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        const ms = String(date.getMilliseconds()).padStart(3, '0');
        
        // Combine into formatted string
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${ms}`;
    }



    
      useEffect(() => {

        const user = localStorage.getItem('definiteagent'); // Retrieve email
        if (user) {
            
          setAgent(user)
        } else {
       
        }
      }, []);



      useEffect(()=>{
        

        const getAgentcode =async()=>{
            const res =await fetch(`https://digitalapi.definiteassurance.com/api/getDealerdetails?email=${agent}`,{
                 method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
            });
            const data = await res.json();
            setAgentcode(data.OID)
            setAgentname(data.Dealer_name)
            setBranch(data.Companyy)
            setDealercode(data.Dealer_type)
            if(data.Approved){
                setApproved(1)
            }
            else{
                setApproved(0)
            }
            
        }

        const getIranumber =async()=>{
            const res = await fetch(`https://digitalapi.definiteassurance.com/api/getIranumber?agent=${agent}`,{
                 method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
            })
            const data = await res.json()
            setIranumber(data.IRANumber)
        }


        if(agent && isAuth){
            getAgentcode()
            getIranumber()
        }

      },[agent,isAuth])

      useEffect(()=>{
        const getCustomers =async()=>{
            const res = await fetch(`https://digitalapi.definiteassurance.com/api/getClients?agent=${agentCode}`,{
                 method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
            });
            const data = await res.json();
            setClients(data)
        }

        const getWallet =async()=>{
            const res = await fetch(`https://digitalapi.definiteassurance.com/api/getWallet?agent=${agentCode}`,{
                 method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
            })
            const data = await res.json();
            setWalletno(data.WalletNo)

        }

        const getCommission =async()=>{
            const res = await fetch(`https://digitalapi.definiteassurance.com/api/getUtilizedCommission?agent=${agentCode}`,{
                 method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
            });
            const data = await res.json();
            if(data.AvailableCommission > 0){
                setAvailablecommission(data.AvailableCommission)
            }
            else{
                setAvailablecommission(0)
            }
            
        }

        if(agentCode && isAuth){
            getCustomers()
            getWallet()
            getCommission();
        }



      },[agentCode, isAuth])

      useEffect(()=>{
        const getWalletbalance =async()=>{
            const res = await fetch(`https://digitalapi.definiteassurance.com/api/getWalletbalance?wallet=${walletNo}`,{
                 method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
            })
            const data = await res.json();
            setWalletbalance(data.Balance)
        }

        if(walletNo && isAuth){
            getWalletbalance()
        }

      },[walletNo,isAuth])

      const getCustomers =async()=>{
        const res = await fetch(`https://digitalapi.definiteassurance.com/api/getClients?agent=${agentCode}`,{
             method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
        });
        const data = await res.json();
        setClients(data)
    }

    useEffect(()=>{
    const getCustomers =async()=>{
        const res = await fetch(`https://digitalapi.definiteassurance.com/api/getClients`,{
             method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
        });
        const data = await res.json();
        setClients(data)
    }
    if(isAuth){
        getCustomers()
    }

    },[isAuth])



    useEffect(()=>{
        const getProducts =async()=>{
            const res = await fetch('https://digitalapi.definiteassurance.com/api/getProducts',{
                 method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
            });
            const data = await res.json();
            setProducts(data)
        }

        const getMakes =async()=>{
            const res = await fetch('https://digitalapi.definiteassurance.com/api/getMakes',{
                 method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
            });
            const data = await res.json();
            setMakes(data)
        }
        if(isAuth){
            getProducts();
            getMakes();
        }

     

    },[isAuth])

    useEffect(()=>{
        const getModels =async()=>{
            const res = await fetch(`https://digitalapi.definiteassurance.com/api/getModels?make=${makeCode}`,{
                 method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
            });
            const data = await res.json();
            setModels(data)

        }

        const getMakedetails =async()=>{
            const res =await fetch(`https://digitalapi.definiteassurance.com/api/getMakedetails?make=${makeCode}`,{
                 method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
            });
            const data = await res.json();
            setMakename(data.Description)
        }
        if(makeCode && isAuth){
            getModels();
            getMakedetails();
        }

    },[makeCode,isAuth])

    useEffect(()=>{
        const getModelname = async()=>{
            const res=  await fetch(`https://digitalapi.definiteassurance.com/api/getModelname?model=${modelCode}`,{
                 method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
            });
            const data = await res.json();
            setModelname(data.Description)
            setBodycode(data.BodyType)
        }
        if(modelCode,isAuth){
            getModelname();
        }
    },[modelCode,isAuth])

    useEffect(()=>{
        const getBodyname = async()=>{
            const res = await fetch(`https://digitalapi.definiteassurance.com/api/getBodyname?body=${bodyCode}`,{
                 method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
            })
            const data = await res.json()
            setBodytype(data.Description)
        }

        if(bodyCode && isAuth){
            getBodyname()
        }
    },[bodyCode,isAuth])



   useEffect(()=>{
    const getProductdetails =async()=>{
        const res = await fetch(`https://digitalapi.definiteassurance.com/api/getThisproduct?OID=${productCode}`,{
            method:"GET",
            headers:{
                'Authorization': `Basic ${credentials}`,
                'Content-Type': "application/json"
            }
        });
        const data = await res.json();
        setProductname(data.ProductDescription)
        // const prd = data.ProductCode
        setPrdcode(data.ProductCode.replace(/PRD-/g, ''))
        setCommissionrate(data.CommissionRate)
        setIracode(data.IRACode)
        setRiskclass(data.RiskClass)

    }

    const getCoveroptions =async()=>{
        const res = await fetch(`https://digitalapi.definiteassurance.com/api/getCoveroptions?product=${productCode}`,{
             method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
        })
        const data = await res.json();
        setCoveroptions(data)
    }

    if(productCode && isAuth){
        getProductdetails()
        getCoveroptions();
    }

   },[productCode,isAuth])

   useEffect(()=>{
    const getInsureditems =async()=>{
        const res = await fetch(`https://digitalapi.definiteassurance.com/api/getInsureditems?coverOption=${coverOptioncode}`,{
             method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
        });
        const data = await res.json();
        setInsureditems(data)
        if(data.length == 1){
              setSelecteditem(data[0].OID)
        }
      

    }

    const getCoveroptiondetails =async()=>{
        const res = await fetch(`https://digitalapi.definiteassurance.com/api/getCoveroptiondetails?cover=${coverOptioncode}`,{
             method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
        });
        const data = await res.json();
        setCoveroption(data.CoverOption)
    }
    if(coverOptioncode && isAuth){
        getInsureditems();
        getCoveroptiondetails();
    }

   },[coverOptioncode,isAuth])

    const getTonnage=()=>{
        if(productCode == 3588){
        if(capacity > 7 && capacity <=9){
            setSelecteditem(insuredItems[0].OID)
        }
        else if(capacity > 9 && capacity <=17 ){
            setSelecteditem(insuredItems[1].OID)
        }
        else if(capacity > 17 && capacity <=25 ){
            setSelecteditem(insuredItems[3].OID)
        }    
            else if(capacity > 25){
            setSelecteditem(insuredItems[25].OID)
        }       
    }
    if(productCode == 3531){
        if(tonnage <= 3){
            setSelecteditem(insuredItems[0].OID)
        }
        else if(tonnage > 3 && tonnage <=8 ){
            setSelecteditem(insuredItems[2].OID)
        }
            else if(tonnage > 8 && tonnage <=20 ){
            setSelecteditem(insuredItems[1].OID)
        }
            
        }

    }
   
    const insertLog=async(agent,activity)=>{
        const res = await fetch(`https://digitalapi.definiteassurance.com/api/insertLogs?activity=${activity}&agent=${agent}`,{
             method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
        });
        const data = await res.json()
    }


   const getQuote =async()=>{
    if(Dealercode !== 185 && Dealercode !== 187){
        toast.error('You need an agent account to proceed')
    }
    else{

    if(approved == 1){

      
    if(productCode && coverOptioncode){
        if(coverOption == 1 || coverOption == 58){
            if(productCode != 4652 && productCode != 4653 && productCode != 4655 && productCode != 3604){
                if(sumInsured >= 500000 ){
                setQuotetext('CALCULATING...')
                const res = await fetch(`https://digitalapi.definiteassurance.com/api/calculatePremium?insuredItem=${selectedItem}&coverOption=${coverOptioncode}&sumInsured=${sumInsured}&capaciy=${capacity}&coverPeriod=${coverPeriod}&product=${productCode}&capacity=${capacity}`,{
                     method:"GET",
                        headers:{
                        'Authorization': `Basic ${credentials}`,
                        'Content-Type': "application/json"
                        }
                })
                const data = await res.json()
                const {premium} = data;
                if(premium){
                    setQuotetext('GET QUOTATION')
                    setPremium(premium)
                    setTraininglevy(0.002*premium)
                    const tl = Math.round(0.002*premium);
                    setPHCF(Math.round(0.0025*premium))
                    const ph = Math.round(0.0025*premium)
                    setBasicpremium(premium+tl+ph+stampduty)
                    setPayamount(premium+tl+ph+stampduty)
                    const com = Math.round(0.1*premium)
                    setCommission(com )
                    const netCom = Math.round(0.1*com)
                    const nc = com - netCom;
                    setNetcommission(nc)
                    setNetprememium((premium+tl+ph+stampduty)-nc)
                    setComm2(com)
                    setNc2(nc)
                    const activity = `Premium calculated for product ${productName}.Amount:Kes ${premium+tl+ph+stampduty}`
                    insertLog(agentCode,activity)
                    setModal6(false)
                    setStep(2)
                }
                else{
                    setQuotetext('GET QUOTATION')
                     const activity = `Premium for product ${productName} not found`
                    insertLog(agentCode,activity)
                    toast.error('NO PREMIUM SET! CONTACT SUPPORT')
                }
            }
            else{
                toast.error('Sum Insured cannot be below Kes. 500,000')
            }

            }
            else{
                if(sumInsured >= 100000 ){
                setQuotetext('CALCULATING...')
                const res = await fetch(`https://digitalapi.definiteassurance.com/api/calculatePremium?insuredItem=${selectedItem}&coverOption=${coverOptioncode}&sumInsured=${sumInsured}&capaciy=${capacity}&coverPeriod=${coverPeriod}&product=${productCode}&capacity=${capacity}`,{
                     method:"GET",
                        headers:{
                        'Authorization': `Basic ${credentials}`,
                        'Content-Type': "application/json"
                        }
                })
                const data = await res.json()
                const {premium} = data;
                if(premium){
                    setQuotetext('GET QUOTATION')
                    setPremium(premium)
                    setTraininglevy(0.002*premium)
                    const tl = Math.round(0.002*premium);
                    setPHCF(Math.round(0.0025*premium))
                    const ph = Math.round(0.0025*premium)
                    setBasicpremium(premium+tl+ph+stampduty)
                    setPayamount(premium+tl+ph+stampduty)
                    const com = Math.round(0.1*premium)
                    setCommission(com )
                    const netCom = Math.round(0.1*com)
                    const nc = com - netCom;
                    setNetcommission(nc)
                    setNetprememium((premium+tl+ph+stampduty)-nc)
                    setComm2(com)
                    setNc2(nc)
                    const activity = `Premium calculated for product ${productName}.Amount:Kes ${premium+tl+ph+stampduty}`
                    insertLog(agentCode,activity)
                    setModal6(false)
                    setStep(2)
                }
                else{
                    setQuotetext('GET QUOTATION')
                     const activity = `Premium for product ${productName} not found`
                    insertLog(agentCode,activity)
                    toast.error('NO PREMIUM SET! CONTACT SUPPORT')
                }
            }
            else{
                toast.error('Sum Insured cannot be below Kes. 100,000')
            }
            }


        }
        else if(coverOption == 2){
            if(capacity){

                if(productCode == 4695 && tonnage > 3){
                    toast.error('Tonnage should be below 3 Tons')
                }
                else{
                                   
                setQuotetext('CALCULATING...')
                const res = await fetch(`https://digitalapi.definiteassurance.com/api/calculatePremium?insuredItem=${selectedItem}&coverOption=${coverOptioncode}&tonnage=${tonnage}&sumInsured=${sumInsured}&capacity=${capacity}&coverPeriod=${coverPeriod}&product=${productCode}`,{
                     method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
                })
                const data = await res.json()
                const {premium,insuredItem} = data;
                if(premium){
                    setSelecteditem(insuredItem)
                    setQuotetext('GET QUOTATION')
                    setPremium(premium)
                    setTraininglevy(0.002*premium)
                    const tl = Math.round(0.002*premium);
                    setPHCF(Math.round(0.0025*premium))
                    const ph = Math.round(0.0025*premium)
                    setBasicpremium(premium+tl+ph+stampduty)
                    setPayamount(premium+tl+ph+stampduty)
                    const com = Math.round(0.1*premium)
                    setCommission(com )
                    const netCom = Math.round(0.1*com)
                    const nc = com - netCom;
                    setNetcommission(nc)
                    setNetprememium((premium+tl+ph+stampduty)-nc)
                     const activity = `Premium calculated for product ${productName}.Amount:Kes ${premium+tl+ph+stampduty}`
                    insertLog(agentCode,activity)
                    setModal6(false)
                    setStep(2)
                }
                else{
                    setQuotetext('GET QUOTATION')
                    toast.error('NO PREMIUM SET! CONTACT SUPPORT')
                     const activity = `Premium calculation for product ${productName} not found`
                    insertLog(agentCode,activity)
                } 

                }
 
            }
            else{
                toast.error('Specify capacity')
            }
        }
    }
    else{
        toast.error('Insufficient information')
    }

    }
    else{

         const activity = `Premium calculation failed! Account not approved`
        insertLog(agentCode,activity)
        toast.error('Your account is not approved. Kindly contact support!')
    }

    }




   
   }

   function formatter(amount) {
    return amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
  }

  const toggle =async()=>{
    setModal(!modal)
  }
  const ste3 =()=>{
    setStep(3)
  }
  const ste4 =()=>{
    setStep(4)
  }

  const username = 'sasapay'; 
  const password = '0vl0~(8U&8x'; 

  const createClient =async()=>{
    if(firstName && lastName && phone && email && idNumber && pin && file1 && file3){
        setSubmittext('PLEASE WAIT...');
        const res = await fetch('https://digitalapi.definiteassurance.com/api/createClient',{
            method:"POST",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                },
            body:JSON.stringify({firstName,lastName,otherNames,phone,email,idNumber,pin, agent:agentCode}),
            credentials:"include"
        })

        const data = await res.json();
        const {success,exists,OID} = data;
        if(success && !exists){
            setSearchTerm(`${firstName} ${lastName}`)
            setFirstname('')
            setLastname('')
            setOthernames('')
            setPhone('')
            setEmail('')
            setIDNumber('')
            setPin('')
            setSubmittext('SUBMIT');
            getCustomers()
            setSelectedClient(OID)
            const activity = `Client ${firstName} ${lastName} created`
            insertLog(agentCode,activity)
            toast.success('Client added successfully')
            setModal(false)

        }
        else if(!success && exists){
            setSubmittext('SUBMIT');
             const activity = `Client ${firstName} ${lastName} failed! Details already exist`
            insertLog(agentCode,activity)
            toast.error('Submitted details already exists!')
        }
        else{
            const activity = `Client ${firstName} ${lastName} failed! Server problem`
            insertLog(agentCode,activity)
            setSubmittext('SUBMIT');
            toast.error('Something went wrong!')
        }
    }
    else{
        toast.error('All fields marked * are required')
    }
  }


  //check double insurance
  useEffect(()=>{
    setChecking(2)
    const checkDoubleinsurance =async()=>{
        const res = await Axios.post('https://sms.definiteassurance.com/webhook/d6c9608b-cd90-481a-995d-d40c908c96db',{
            chasis:chassis,reg,commence:commencementDate,end:expiryDate
        })
 
        setChecking(1)
       
        setDoubleinsuranceloading(true)
        setDoubleinsuracemessage('Checking double insurance....')
        if(res.data.success){
            setDoubleinsurancestatus(true)
            setDoubleinsuracemessage(`Vehicle has active certificate in ${res.data.company}. Expected expiry: ${res.data.endDate}`)
            // toast.error('Vehicle has double insurance')
        }
        else{
            setDoubleinsurancestatus(false)
            setDoubleinsuracemessage('No double insurance')
        }
    }

    if(reg && chassis){
        checkDoubleinsurance()
    }

  },[reg,chassis])

  const createNewproposal =async()=>{
    setMakepaymenttext('LOADING...')

    //check if the proposal insists
    const checkProposal = await fetch(`https://digitalapi.definiteassurance.com/api/checkProposalexists?agent=${agentCode}&reg=${reg}`,{
         method:"GET",
        headers:{
            'Authorization': `Basic ${credentials}`,
            'Content-Type': "application/json"
        }
    })
    const result = await checkProposal.json()
    if(result.exists1){

        const res = await fetch('https://digitalapi.definiteassurance.com/api/updateExisting',{
            method:"POST",
             headers:{
            'Authorization': `Basic ${credentials}`,
            'Content-Type': "application/json"
            },
            body:JSON.stringify({agentCode,commencementUnix,expiryUnix,today,coverDays,reg,productCode,payAmount,premium,basicPremium,commission,stampduty,PHCF,trainingLevy,netCommission,netPremium,selectedClient}),
            credentials:"include"
        })

        const {success,policyNumber,proposalOID,insuredOID,IOID} = await res.json()
        if(success){
            setInsureschedule(IOID)
            setPolicynumber(policyNumber)
            setProposalOID(proposalOID)
            setInsuredOID(insuredOID)
            setfolderID(proposalOID)

            setMakepaymenttext('MAKE PAYMENT')
                
            const activity = `Existing proposal updated. OID ${proposalOID}`
            insertLog(agentCode,activity)
            setModal2(!modal2)
        }
        else{
            setMakepaymenttext('MAKE PAYMENT')
            const activity = `Unable to update existing proposal OID ${proposalOID}`
            insertLog(agentCode,activity)
            toast.error('Proposal with same registration number existing. Unable to update!')
        }
    }
    else if(result.exists2){
        toast.error('A proposal with the same registration number already exists')
    }
    else if(!result.exists1 && !result.exists2){

         const res = await fetch('https://digitalapi.definiteassurance.com/api/createProposal2',{
        method:"POST",
        headers:{
            'Authorization': `Basic ${credentials}`,
            'Content-Type': "application/json"
        },
        body:JSON.stringify({commissionRate,agentCode,agentName,prdCode,client,commencementUnix,expiryUnix,today,coverDays,reg,productCode,payAmount,premium,basicPremium,commission,stampduty,PHCF,trainingLevy,netCommission,netPremium,selectedClient,makeCode,modelCode,capacity,color,tonnage,yom,coverOptioncode,sumInsured,chassis,engineNumber,cc,selectedItem,branch}),
        credentials:'include'
    })

    const data = await res.json();
    const {success,policyNumber,proposalOID,insuredOID,IOID} = data;
    setInsureschedule(IOID)
    setPolicynumber(policyNumber)
    setProposalOID(proposalOID)
    setInsuredOID(insuredOID)

    setfolderID(proposalOID)
    const formData = new FormData();
        formData.append('file', file);
        formData.append('agent', agentCode);
        formData.append('proposal', proposalOID);
      
    
        const requestOptions = {
              method: 'POST',
              body: formData
            };
    
        try {
    
         
          const response = await axios.post('https://digitalapi.definiteassurance.com/api/uploadDocument', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
            withCredentials:'false'
          } 
          );
        }
        catch(e){
            //pass
        }
    if(success){    
         setMakepaymenttext('MAKE PAYMENT')
        if(file1 && file2){
             handleUpload1(proposalOID)
        }
        const activity = `New proposal created. OID ${proposalOID}`
        insertLog(agentCode,activity)
        setModal2(!modal2)
    }
    else{
        const activity = `New proposal failed!`
        insertLog(agentCode,activity)
        toast.error('Something went wrong!')
        setMakepaymenttext('MAKE PAYMENT')
    }

    }



   
  }

  const makePayment =async()=>{
    if(proposalOID !== ''){
         setModal2(!modal2)
    }
    else{
         if(selectedClient && commencement &&  reg && makeCode &&  modelCode && chassis && engineNumber && cc){
        if(doubleInsurancestatus){
            toast.error(doubleinsuranceMessage)
        }
        else{
            if((coverOption == 1 || coverOption == 58) && yom >= 2010){
                 createNewproposal()
            }
            else if((coverOption == 1 || coverOption == 58) && yom < 2010){
                toast.error('Year of manufacture cannot be below 2010')
            }
            else if(coverOption == 2){
                createNewproposal()
            }
          
        }
    }
    else{
        toast.error('All fields are required!')
    }
    }

   
  }

//   //calculate pay amount
//   useEffect(()=>{
//     const commission = 0.1*basicPremium
//     if(selectedOption == 'GROSS'){
//         setPayamount(basicPremium)
//         setCommission(comm2)
//         setNetcommission(nc2)
//     }
//     else{
//         setCommission(0.00)
//         setNetcommission(0.00)
//         setPayamount(Math.round(netPremium))
//     }

//   },[selectedOption])

  function generateUniqueId() {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < 8; i++) {
        const randomIndex = Math.floor(Math.random() * chars.length);
        result += chars[randomIndex];
    }
    return result;
}

function getFormattedDateTime() {
    const now = new Date();
    
    // Extract date parts (YYYY-MM-DD)
    const datePart = now.toISOString().split('T')[0];
    
    // Extract time parts (HH:MM:SS.mmm)
    const timePart = now.toISOString().split('T')[1].replace('Z', '');
    
    // Combine and return
    return `${datePart} ${timePart}`;
}


  const createProposal =async()=>{
    

    if(paymentMode == 0 && utilize == 0){
        setMpesaclicked(true)
        setPaytext('CHECKING PAYMENT...')
        // setModal2(false)
        toast.success('Prompt sent to phone!')
        const formattedNumber =clientPhone.slice(1);
        const formattedNumber2 ="254" + mpesaPhone.slice(1);
        const ref = generateUniqueId();
        const qref = `QP${ref}`
        const uuid = uuidv4();
        const dateDone = getFormattedDateTime();
        setPrompt(true)
        const res2 = await Axios.post('https://workflows.uuidesign.xyz/webhook/0623c8f7-d286-45c4-b823-2675d25de35a',{formattedNumber2,payAmount,reg,uuid,qref,dateDone})

        
        if(res2.data.success){
            const transaction=res2.data.transactionId
            setTransactionid(res2.data.transactionId)
             const activity = `Payment Kes.${payAmount} for ${reg} received - ${transaction}`
            insertLog(agentCode,activity)

        

            const res = await fetch('https://digitalapi.definiteassurance.com/api/createProposal',{
                method:"POST",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                },
                body:JSON.stringify({utilize:0,proposalOID,commissionRate,agentCode,agentName,prdCode,client,commencementUnix,expiryUnix,today,coverDays,reg,productCode,payAmount,premium,basicPremium,commission,stampduty,PHCF,trainingLevy,netCommission,netPremium,selectedClient,makeCode,modelCode,capacity,color,tonnage,yom,coverOptioncode,sumInsured,chassis,engineNumber,cc,selectedItem,transaction}),
                credentials:'include'
            })

            const dataa=await res.json()
            const {success} = dataa;

           
       
                
                    const formData = new FormData();
                    formData.append('file', file);
                    formData.append('agent', agentCode);
                    formData.append('proposal', proposalOID);
                
                
                    const requestOptions = {
                        method: 'POST',
                        body: formData
                        };
                
                    try {
                
                    const response = await axios.post('https://digitalapi.definiteassurance.com/api/uploadDocument', formData, {
                        headers: {
                        'Content-Type': 'multipart/form-data',
                        },
                        withCredentials:'false'
                    } 
                    );
                    }
                    catch(e){
                        //pass
                     }

                const activity1 = `Proposal ${proposalOID} approved`
                const activity2 = `Proposal ${proposalOID} started to generate certificate`
                insertLog(agentCode,activity1)

                setPaytext('GENERATING CERTIFICATE...')
                
                insertLog(agentCode,activity2)
                //production cert generation
                
                const res3 = await Axios.post(`https://sms.definiteassurance.com/webhook/c924c7c4-d115-4724-a78c-27048b99b6f0`,{IOID:insuredSchedule,insuredOID,dateDone,selectedItem,proposalOID,coverType,clientName,policyNumber,commencementUnix,commencementDate,expiryUnix,expiryDate,reg,chassis,clientPhone:formattedNumber,bodyType,capacity,makeName,modelName,engineNumber,clientEmail,sumInsured,clientPin,yom,iraCode,tonnage,iraNumber})

                //uat cert generation
               // const res3 = await Axios.post(`https://workflows.uuidesign.xyz/webhook/c924c7c4-d115-4724-a78c-27048b99b6f0`,{IOID:insuredSchedule,insuredOID,dateDone,selectedItem,proposalOID,coverType,clientName,policyNumber,commencementUnix,commencementDate,expiryUnix,expiryDate,reg,chassis,clientPhone:formattedNumber,bodyType,capacity,makeName,modelName,engineNumber,clientEmail,sumInsured,clientPin,yom,iraCode,tonnage,iraNumber})
    
                if(res3.data.success){
                     insertCertificate(res3.data.certURL,res3.data.certNo)
                    setCertURL(res3.data.certURL)
                    setIscert(1)
                    const activity = `Certificate for ${reg} generated`
                    insertLog(agentCode,activity)
                    
                }
                else{
                     insertCertificateError(res3.data.errorMessage)
                    const activity = `Certificate for ${reg} error-${res3.data.errorMessage}`
                    insertLog(agentCode,activity)
                    setIscert(2)
                    setErrorcode(res3.data.errorCode)
                    setErrormessage(res3.data.errorMessage)
                }
            }
            
        
            
            else{
                setPromptid(1)
                toast.error('PAYMENT NOT RECEIVED')
                setResendtext('RESEND REQUEST')
            }
        }
    

    



    else if(paymentMode == 1 ){
        if(payAmount > walletBallance){
            const bal = payAmount - walletBallance;
            toast.error(`INSUFFICIENT WALLET BALANCE. TOP UP TO PROCEED`)
            const activity = `Insuffient wallet balance`
            insertLog(agentCode,activity)
        }
        else{
            const success = 1
            if(success == 1){    
              
                setPaytext('CHECKING WALLET...')
                // setModal2(false)
              
                const formattedNumber =clientPhone.slice(1);
                const formattedNumber2 ="254" + mpesaPhone.slice(1);
                const ref = generateUniqueId();
                const qref = `QP${ref}`
                const uuid = uuidv4();
                const dateDone = getFormattedDateTime();
                const newBalance = walletBallance - payAmount
                const res2 = await Axios.post('https://sms.definiteassurance.com/webhook/04a58cac-a6b4-4bde-883a-b364f32d9ae9',{formattedNumber2,payAmount,newBalance,reg,uuid,qref,dateDone,walletNo})

                
                
                    if(res2.data.success){
                         const activity = `Payment for proposal ${proposalOID} done by wallet`
                        insertLog(agentCode,activity)
                        const res = await fetch('https://digitalapi.definiteassurance.com/api/createProposal',{
                           method:"POST",
                            headers:{
                            'Authorization': `Basic ${credentials}`,
                            'Content-Type': "application/json"
                            },
                            body:JSON.stringify({utilize:0,proposalOID,commissionRate,agentCode,agentName,prdCode,client,commencementUnix,expiryUnix,today,coverDays,reg,productCode,payAmount,premium,basicPremium,commission,stampduty,PHCF,trainingLevy,netCommission,netPremium,selectedClient,makeCode,modelCode,capacity,color,tonnage,yom,coverOptioncode,sumInsured,chassis,engineNumber,cc,selectedItem}),
                            credentials:'include'
                        })

                            const formData = new FormData();
                            formData.append('file', file);
                            formData.append('agent', agentCode);
                            formData.append('proposal', proposalOID);
                        
                        
                            const requestOptions = {
                                method: 'POST',
                                body: formData
                                };
                        
                            try {
                        
                            
                            const response = await axios.post('https://digitalapi.definiteassurance.com/api/uploadDocument', formData, {
                                headers: {
                                'Content-Type': 'multipart/form-data',
                                },
                                withCredentials:'false'
                            } 
                            );
                            }
                            catch(e){
                                //pass
                            }

                             const activity1 = `Proposal ${proposalOID} approved`
                            insertLog(agentCode,activity1)
                        setPaytext('GENERATING CERTIFICATE...')

                        //production
                       const res3 = await Axios.post(`https://sms.definiteassurance.com/webhook/c924c7c4-d115-4724-a78c-27048b99b6f0`,{IOID:insuredSchedule,insuredOID,dateDone,selectedItem,proposalOID,coverType,clientName,policyNumber,commencementUnix,commencementDate,expiryUnix,expiryDate,reg,chassis,clientPhone:formattedNumber,bodyType,capacity,makeName,modelName,engineNumber,clientEmail,sumInsured,clientPin,yom,iraCode,tonnage,iraNumber})

                        //uat
                       //const res3 = await Axios.post(`https://workflows.uuidesign.xyz/webhook/c924c7c4-d115-4724-a78c-27048b99b6f0`,{IOID:insuredSchedule,insuredOID,dateDone,selectedItem,proposalOID,coverType,clientName,policyNumber,commencementUnix,commencementDate,expiryUnix,expiryDate,reg,chassis,clientPhone:formattedNumber,bodyType,capacity,makeName,modelName,engineNumber,clientEmail,sumInsured,clientPin,yom,iraCode,tonnage,iraNumber})
            
                        if(res3.data.success){
                             insertCertificate(res3.data.certURL,res3.data.certNo)
                             const activity = `Certificate for ${reg} generated`
                            insertLog(agentCode,activity)
                            setCertURL(res3.data.certURL)

                            setTimeout(() => {
                                setIscert(1)
                            }, 3000); 
                            
                            
                        }
                        else{
                            insertCertificate(res3.data.errorMessage)
                             const activity = `Certificate for ${reg} error-${res3.data.errorMessage}`
                            insertLog(agentCode,activity)
                            setIscert(2)
                            setErrorcode(res3.data.errorCode)
                            setErrormessage(res3.data.errorMessage)
                        }
                    }
                    else{
                        toast.error('SOMETHING WENT WRONG FROM THE WALLET')
                        setPaytext('SEND REQUEST')
                    }
        
               
        
               
        
        
            }
            else{
                setPaytext('SEND REQUEST')
                toast.error('Something went wrong. Please contact support!')
            }

        }

    }

    else if(utilize == 1 ){
        if(payAmount > availableCommission){
            const bal = payAmount - availableCommission;
            toast.error(`INSUFFICIENT COMMISSION BALANCE AVAILABLE. TOP UP ${bal} TO PROCEED`)

             const activity = `Insufficient commission for utilization`
            insertLog(agentCode,activity)
        }
        else{
           const success = 1
            if(success == 1){    
                const activity = `Payment by commission utilization for ${proposalOID} successful`
                insertLog(agentCode,activity)
               
                setPaytext('CHECKING BALANCE...')
                // setModal2(false)
               
                const formattedNumber =clientPhone.slice(1);
                const formattedNumber2 ="254" + mpesaPhone.slice(1);
                const ref = generateUniqueId();
                const qref = `QP${ref}`
                const uuid = uuidv4();
                const dateDone = getFormattedDateTime();
                const newBalance = walletBallance - payAmount


                        const res = await fetch('https://digitalapi.definiteassurance.com/api/createProposal',{
                            method:"POST",
                            headers:{
                            'Authorization': `Basic ${credentials}`,
                            'Content-Type': "application/json"
                            },
                            body:JSON.stringify({utilize:1,proposalOID,commissionRate,agentCode,agentName,prdCode,client,commencementUnix,expiryUnix,today,coverDays,reg,productCode,payAmount,premium,basicPremium,commission,stampduty,PHCF,trainingLevy,netCommission,netPremium,selectedClient,makeCode,modelCode,capacity,color,tonnage,yom,coverOptioncode,sumInsured,chassis,engineNumber,cc,selectedItem}),
                            credentials:'include'
                        })
    const formData = new FormData();
        formData.append('file', file);
        formData.append('agent', agentCode);
        formData.append('proposal', proposalOID);
      
    
        const requestOptions = {
              method: 'POST',
              body: formData
            };
    
        try {
    
         
          const response = await axios.post('https://digitalapi.definiteassurance.com/api/uploadDocument', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
            withCredentials:'false'
          } 
          );
        }
        catch(e){
            //pass
        }
                    const activity1 = `Proposal ${proposalOID} approved`
                    insertLog(agentCode,activity)

                        setPaytext('GENERATING CERTIFICATE...')
                        
                        //productions
                        const res3 = await Axios.post(`https://sms.definiteassurance.com/webhook/c924c7c4-d115-4724-a78c-27048b99b6f0`,{IOID:insuredSchedule,insuredOID,dateDone,selectedItem,proposalOID,coverType,clientName,policyNumber,commencementUnix,commencementDate,expiryUnix,expiryDate,reg,chassis,clientPhone:formattedNumber,bodyType,capacity,makeName,modelName,engineNumber,clientEmail,sumInsured,clientPin,yom,iraCode,tonnage,iraNumber})

                        //uat
                        //const res3 = await Axios.post(`https://workflows.uuidesign.xyz/webhook/c924c7c4-d115-4724-a78c-27048b99b6f0`,{IOID:insuredSchedule,insuredOID,dateDone,selectedItem,proposalOID,coverType,clientName,policyNumber,commencementUnix,commencementDate,expiryUnix,expiryDate,reg,chassis,clientPhone:formattedNumber,bodyType,capacity,makeName,modelName,engineNumber,clientEmail,sumInsured,clientPin,yom,iraCode,tonnage,iraNumber})
                        if(res3.data.success){
                             insertCertificate(res3.data.certURL,res3.data.certNo)
                              const activity = `Certificate for ${reg} generated`
                            insertLog(agentCode,activity)
                            setCertURL(res3.data.certURL)

                            setTimeout(() => {
                                setIscert(1)
                            }, 3000); 
                            
                            
                        }
                        else{
                              insertCertificate(res3.data.errorMessage)
                            const activity = `Certificate for ${reg} error-${res3.data.errorMessage}`
                            insertLog(agentCode,activity)
                            setIscert(2)
                            setErrorcode(res3.data.errorCode)
                            setErrormessage(res3.data.errorMessage)
                        }
                    }
                    else{
                        toast.error('SOMETHING WENT WRONG FROM THE WALLET')
                        setPaytext('SEND REQUEST')
                    }


        }

    }
  }

  const close2 =()=>{
    setIscert(0)
    setPaytext('SEND REQUEST')
    setModal2(false);
    
  }
  const finish=()=>{
    window.location.reload(false)
  }
  
  const generateCertificate =async()=>{
        setPaytext('PLEASE WAIT')

    const formattedNumber =clientPhone.slice(1);
    const formattedNumber2 ="254" + mpesaPhone.slice(1);
    const ref = generateUniqueId();
    const qref = `QP${ref}`
    const uuid = uuidv4();
        const dateDone = getFormattedDateTime();
    const res = await fetch('https://digitalapi.definiteassurance.com/api/createProposal',{
                method:"POST",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                },
                body:JSON.stringify({utilize:0,proposalOID,commissionRate,agentCode,agentName,prdCode,client,commencementUnix,expiryUnix,today,coverDays,reg,productCode,payAmount,premium,basicPremium,commission,stampduty,PHCF,trainingLevy,netCommission,netPremium,selectedClient,makeCode,modelCode,capacity,color,tonnage,yom,coverOptioncode,sumInsured,chassis,engineNumber,cc,selectedItem,transaction:transactionId}),
                credentials:'include'
            })
            
                   const formData = new FormData();
                formData.append('file', file);
                formData.append('agent', agentCode);
                formData.append('proposal', proposalOID);
            
            
                const requestOptions = {
                    method: 'POST',
                    body: formData
                    };
            
                try {
            
                
                const response = await axios.post('https://digitalapi.definiteassurance.com/api/uploadDocument', formData, {
                    headers: {
                    'Content-Type': 'multipart/form-data',
                    },
                    withCredentials:'false'
                } 
                );
                }
                catch(e){
                    //pass
                }

            const activity = `Proposal ${proposalOID} approved`
            const activity1 = `Proposal ${proposalOID} started to generate certificate`
            insertLog(agentCode,activity)
            setPaytext('GENERATING CERTIFICATE...')
             insertLog(agentCode,activity1)
            //production
           const res3 = await Axios.post(`https://sms.definiteassurance.com/webhook/c924c7c4-d115-4724-a78c-27048b99b6f0`,{IOID:insuredSchedule,insuredOID,dateDone,selectedItem,proposalOID,coverType,clientName,policyNumber,commencementUnix,commencementDate,expiryUnix,expiryDate,reg,chassis,clientPhone:formattedNumber,bodyType,capacity,makeName,modelName,engineNumber,clientEmail,sumInsured,clientPin,yom,iraCode,tonnage,iraNumber})
            
            //uat
            //const res3 = await Axios.post(`https://workflows.uuidesign.xyz/webhook/c924c7c4-d115-4724-a78c-27048b99b6f0`,{IOID:insuredSchedule,insuredOID,dateDone,selectedItem,proposalOID,coverType,clientName,policyNumber,commencementUnix,commencementDate,expiryUnix,expiryDate,reg,chassis,clientPhone:formattedNumber,bodyType,capacity,makeName,modelName,engineNumber,clientEmail,sumInsured,clientPin,yom,iraCode,tonnage,iraNumber})
            const res4 = await fetch(`https://digitalapi.definiteassurance.com/api/processMpesa?code=${mpesaCode}`);

            if(res3.data.success){
                 insertCertificate(res3.data.certURL,res3.data.certNo)
                const activity = `Certificate for ${reg} generated`
                insertLog(agentCode,activity)
                setCertURL(res3.data.certURL)

                setTimeout(() => {
                    setIscert(1)
                }, 3000); 
                
                
            }
            else{
                 insertCertificateError(res3.data.errorMessage)
                const activity = `Certificate for ${reg} error-${res3.data.errorMessage}`
                insertLog(agentCode,activity)
                setIscert(2)
                setErrorcode(res3.data.errorCode)
                setErrormessage(res3.data.errorMessage)
            }
        }


    const retryCertficate =async()=>{
              const dateDone = getFormattedDateTime();
                  const formattedNumber =clientPhone.slice(1);
            const formattedNumber2 ="254" + mpesaPhone.slice(1);
            const ref = generateUniqueId();
            setRetrytext('Please wait...')
           // const res3 = await Axios.post(`https://sms.definiteassurance.com/webhook/c924c7c4-d115-4724-a78c-27048b99b6f0`,{IOID:insuredSchedule,insuredOID,dateDone,selectedItem,proposalOID,coverType,clientName,policyNumber,commencementUnix,commencementDate,expiryUnix,expiryDate,reg,chassis,clientPhone:formattedNumber,bodyType,capacity,makeName,modelName,engineNumber,clientEmail,sumInsured,clientPin,yom,iraCode,tonnage,iraNumber})
            
            //uat
            const res3 = await Axios.post(`https://workflows.uuidesign.xyz/webhook/c924c7c4-d115-4724-a78c-27048b99b6f0`,{IOID:insuredSchedule,insuredOID,dateDone,selectedItem,proposalOID,coverType,clientName,policyNumber,commencementUnix,commencementDate,expiryUnix,expiryDate,reg,chassis,clientPhone:formattedNumber,bodyType,capacity,makeName,modelName,engineNumber,clientEmail,sumInsured,clientPin,yom,iraCode,tonnage,iraNumber})

            if(res3.data.success){
                 setRetrytext('Retry')
                 insertCertificate(res3.data.certURL,res3.data.certNo)
                const activity = `Certificate for ${reg} generated`
                insertLog(agentCode,activity)
                setCertURL(res3.data.certURL)

                setTimeout(() => {
                    setIscert(1)
                }, 3000); 
                
                
            }
            else{
                setRetrytext('Retry')
                 insertCertificateError(res3.data.errorMessage)
                const activity = `Certificate for ${reg} error-${res3.data.errorMessage}`
                insertLog(agentCode,activity)
                setIscert(2)
                setErrorcode(res3.data.errorCode)
                setErrormessage(res3.data.errorMessage)
            }
    }



  const resendRequest =async()=>{
        
        setResendtext('CHECKING PAYMENT...')
        // setModal2(false)
        toast.success('Prompt sent to phone!')
        const formattedNumber =clientPhone.slice(1);
        const formattedNumber2 ="254" + mpesaPhone.slice(1);
        const ref = generateUniqueId();
        const qref = `QP${ref}`
        const uuid = uuidv4();
        const dateDone = getFormattedDateTime();

        const res2 = await Axios.post('https://workflows.uuidesign.xyz/webhook/0623c8f7-d286-45c4-b823-2675d25de35a',{formattedNumber2,payAmount,reg,uuid,qref,dateDone})    
      
        if(res2.data.success){
                const transaction = res2.data.transactionId
                setTransactionid(transaction)
              const activity = `Payment kes.${payAmount} for proposal ${proposalOID} received - ${transaction}`
            insertLog(agentCode,activity)

            const res = await fetch('https://digitalapi.definiteassurance.com/api/createProposal',{
               method:"POST",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                },
                body:JSON.stringify({utilize:0,proposalOID,commissionRate,agentCode,agentName,prdCode,client,commencementUnix,expiryUnix,today,coverDays,reg,productCode,payAmount,premium,basicPremium,commission,stampduty,PHCF,trainingLevy,netCommission,netPremium,selectedClient,makeCode,modelCode,capacity,color,tonnage,yom,coverOptioncode,sumInsured,chassis,engineNumber,cc,selectedItem,transaction}),
                credentials:'include'
            })


             const dataa=await res.json()
            const {success,trans,ref} = dataa;

                
                   const formData = new FormData();
        formData.append('file', file);
        formData.append('agent', agentCode);
        formData.append('proposal', proposalOID);
      
    
        const requestOptions = {
              method: 'POST',
              body: formData
            };
    
        try {
    
         
          const response = await axios.post('https://digitalapi.definiteassurance.com/api/uploadDocument', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
            withCredentials:'false'
          } 
          );
        }
        catch(e){
            //pass
        }

            const activity1 = `Proposal ${proposalOID} started to generate certificate`
            insertLog(agentCode,activity)
            setResendtext('GENERATING CERTIFICATE...')
                insertLog(agentCode,activity1)
            //production
            const res3 = await Axios.post(`https://sms.definiteassurance.com/webhook/c924c7c4-d115-4724-a78c-27048b99b6f0`,{IOID:insuredSchedule,insuredOID,dateDone,selectedItem,proposalOID,coverType,clientName,policyNumber,commencementUnix,commencementDate,expiryUnix,expiryDate,reg,chassis,clientPhone:formattedNumber,bodyType,capacity,makeName,modelName,engineNumber,clientEmail,sumInsured,clientPin,yom,iraCode,tonnage,iraNumber})

            //uat
            //const res3 = await Axios.post(`https://workflows.uuidesign.xyz/webhook/c924c7c4-d115-4724-a78c-27048b99b6f0`,{IOID:insuredSchedule,insuredOID,dateDone,selectedItem,proposalOID,coverType,clientName,policyNumber,commencementUnix,commencementDate,expiryUnix,expiryDate,reg,chassis,clientPhone:formattedNumber,bodyType,capacity,makeName,modelName,engineNumber,clientEmail,sumInsured,clientPin,yom,iraCode,tonnage,iraNumber})

            if(res3.data.success){
                insertCertificate(res3.data.certURL,res3.data.certNo)
                const activity = `Certificate for ${reg} generated`
                insertLog(agentCode,activity)
                setCertURL(res3.data.certURL)
                setIscert(1)
                
            }
            else{
                    insertCertificate(res3.data.errorMessage)
                    const activity = `Certificate for ${reg} error-${res3.data.errorMessage}`
                        insertLog(agentCode,activity)
                setIscert(2)
                setErrorcode(res3.data.errorCode)
                setErrormessage(res3.data.errorMessage)
            }


            }
            
            
            else{
                setPromptid(1)
                toast.error('PAYMENT NOT RECEIVED')
                setResendtext('RESEND REQUEST')
            }
        }

  function formatDate2(inputDate) {
    const date = new Date(inputDate);
    
    // Get day, month, year
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    
    // Get hours and minutes in 12-hour format
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    
    return `${month}/${day}/${year} ${String(hours).padStart(2, '0')}.${minutes}${ampm}`;
  }

useEffect(()=>{

    if(utilize == 1){
        setIsmpesa(false)
    }
    if(utilize == 0){
        setIsmpesa(true)
    }

},[utilize])

useEffect(()=>{

    if(paymentMode == 1){
        setIsmpesa(false)
    }
    if(paymentMode == 0){
        setIsmpesa(true)
    }

},[paymentMode])

// useEffect(()=>{

//     const getError =async()=>{
//         const res = await fetch(`https://digitalapi.definiteassurance.com/api/getErrors?code=${errorCode}`)
//         const data = await res.json()
//         setErrormessage(data.ErrorDescription)
//     }

//     if(errorCode){
//         getError();
//     }

// },[errorCode])

const openModule3 =async()=>{
    setModal3(true)
    setTimeout(() => {
       setCheckmpesa(true)
    }, 5000)

}
const close3 =()=>{
    setCheckmpesa(false)
    setModal3(false)
}

const checkMpesatransaction =async()=>{
    if(mpesaCode){
        setVerifytext('Verifying.....')
        
        const res = await fetch(`https://digitalapi.definiteassurance.com/api/checkMpesa?code=${mpesaCode}&amount=${payAmount}&reg=${reg}`,{
             method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
        });
        const data = await res.json();
        const {success} = data;
        if(success){
            toast.success('Payment received')
            setVerifytext('VERIFY')
            setModal3(false)
            generateCertificate()
        }
        else{
            toast.error('No transaction with the given transaction number')
            setVerifytext('VERIFY')
        }
    }


}

const insertCertificate=async(certLink,certNo)=>{
    const res = await fetch('https://digitalapi.definiteassurance.com/api/insertCertificate',{
       method:"POST",
        headers:{
            'Authorization': `Basic ${credentials}`,
            'Content-Type': "application/json"
        },
        body:JSON.stringify({proposalOID,insuredOID,expiryUnix,commencementUnix,certNo,certLink,today})
    })

    const data = await res.json()
}


const insertCertificateError=async(errorMes)=>{
    const res = await fetch('https://digitalapi.definiteassurance.com/api/insertCertificateerror',{
       method:"POST",
        headers:{
            'Authorization': `Basic ${credentials}`,
            'Content-Type': "application/json"
        },
        body:JSON.stringify({proposalOID,insuredOID,expiryUnix,commencementUnix,errorMes,today})
    })

    const data = await res.json()
}

  return (
    <div>
        <div className="page-content">
              <Breadcrumbs title="Definite Assurance" breadcrumbItem="New Cover" />
               <Card className="mini-stats-wid">
                    <CardBody>
                       <div className="coverContainer">
                      
                        <ToastContainer />
                                            {step == 1 &&
                    
                         <div className="newDesign">
                            <h4 style={{marginBottom:'3%',color:"#095034"}}>Which cover do you want?</h4>
                    <div className="productsContainer">
                        <div className="productImages">
                            <div className="productImage">
                                <img className="pImage" src="/private.jpg" alt="" />
                                <button onClick={calculate}  className="productName" value={3617}>Motor Private</button>
                            </div>
                            <div className="productImage">
                                <img className="pImage" src="/chauffeur.jpg" alt="" />
                                 <button onClick={calculate}  className="productName" value={3582}>Private Hire - Chauffeur Driven</button>
                            </div>
                            <div className="productImage">
                                <img className="pImage" src="/self drive.jpg" alt="" />
                                 <button onClick={calculate}  className="productName" value={3583}>Private Hire - Self Drive</button>
                            </div>
                            <div className="productImage">
                                <img className="pImage" src="/private.jpg" alt="" />
                                 <button onClick={calculate} className="productName" value={4694}>Motor Private TOR</button>
                            </div>
                        </div>
                         <div className="productImages">
                            <div className="productImage">
                                <img className="pImage" src="/psvmatatu.PNG" alt="" />
                                <button onClick={calculate}  className="productName" value={4638}>PSV MATATU(7-35)</button>
                            </div>
                            <div className="productImage">
                                <img className="pImage" src="/psvbus.jpg" alt="" />
                                 <button onClick={calculate}  className="productName" value={3582}>PSV BUS(36-105)</button>
                            </div>
                            <div className="productImage">
                                <img className="pImage" src="/boda.jpg" alt="" />
                                 <button onClick={calculate}  className="productName" value={4652}>PSV Boda Boda</button>
                            </div>
                            <div className="productImage">
                                <img className="pImage" src="/tuktukpsv.jpg" alt="" />
                                 <button onClick={calculate} className="productName" value={4655}>PSV Tuk Tuk</button>
                            </div>
                        </div>

                         <div className="productImages">
                            <div className="productImage">
                                <img className="pImage" src="/motorcom.jpg" alt="" />
                                <button onClick={calculate}  className="productName" value={4630}>Motor Commercial</button>
                            </div>
                            <div className="productImage">
                                <img className="pImage" src="/institutional.jpg" alt="" />
                                 <button onClick={calculate}  className="productName" value={3588}>Motor Commercial Instituitional</button>
                            </div>
                            <div className="productImage">
                                <img className="pImage" src="/agricultural.jpg" alt="" />
                                 <button onClick={calculate}  className="productName" value={3592}>Motor Commercial Agricultural</button>
                            </div>
                            <div className="productImage">
                                <img className="pImage" src="/tuktuk.jpg" alt="" />
                                 <button onClick={calculate} className="productName" value={3604}>Tuk Tuk Commercial</button>
                            </div>
                        </div>
                        <div className="productImages">
                            <div className="productImage" style={{width:'270px'}}>
                                <img className="pImage" src="/motorcom.jpg" alt="" />
                                <button onClick={calculate}  className="productName" value={4695}>Motor Commercial TOR</button>
                            </div>
                            <div className="productImage" style={{width:'270px'}}>
                                <img className="pImage" src="/motorcycleprivate.jpg" alt="" />
                                 <button onClick={calculate}  className="productName" value={4653}>Motorcycle Private</button>
                            </div>
                            {/* <div className="productImage">
                                <img className="pImage" src="/agricultural.jpg" alt="" />
                                 <button onClick={calculate}  className="productName" value={3592}>Motor Commercial Agricultural</button>
                            </div>
                            <div className="productImage">
                                <img className="pImage" src="/tuktuk.jpg" alt="" />
                                 <button onClick={calculate} className="productName" value={3604}>Tuk Tuk Commercial</button>
                            </div> */}
                        </div>
                        </div>

                        </div>
                    
                    }

                    {step == 2 &&
                        <div className="coverEntry">
                            <h4>STEP 2 -  GET COVER</h4>
                            <div className="table-responsive" id="dataTable" >
                                <Table striped bordered hover>

                                    <thead>
                                        <tr>
                                            <th scope="col">ITEM</th>
                                            <th scope="col">AMOUNT (KES)</th>                         
                                        </tr>
                                    </thead>
                                    <tbody>
                                            <tr>
                                                <td>BASIC PREMIUM</td>
                                                <td><strong>{formatter(premium)}</strong></td>
                                            </tr>
                                            <tr>
                                                <td>NET PREMIUM</td>
                                                <td><strong>{formatter(netPremium)}</strong></td>
                                            </tr>
                                            <tr>
                                                <td>PHCF</td>
                                                <td><strong>{formatter(PHCF)}</strong></td>
                                            </tr>
                                            <tr>
                                                <td>TRANING LEVY</td>
                                                <td><strong>{formatter(trainingLevy)}</strong></td>
                                            </tr>
                                            <tr>
                                                <td>STAMP DUTY</td>
                                                <td><strong>{formatter(stampduty)}</strong></td>
                                            </tr>
                                            <tr>
                                                <td><strong>GROSS PREMIUM</strong></td>
                                                <td><strong>{formatter(basicPremium)}</strong></td>
                                            </tr>
                                            <tr>
                                                <td><strong>GROSS COMMISSION</strong></td>
                                                <td><strong>{formatter(commission)}</strong></td>
                                            </tr>

                                    
                                    </tbody>
                                </Table>
                                </div>
                          
                                <div className="stepButtons">
                                    <Button color="danger" className="quoteButton" onClick={()=>{setStep(1)}}>PREVIOUS STEP</Button>
                                    <Button color="success" className="quoteButton" onClick={ste3}>BUY COVER</Button>
                                </div>
                                

                            
                         
                        </div>

                    }
                    {step == 3 &&
                        <div className="coverEntry">
                            <h4>STEP 3 -  RISK DETAILS</h4>
                            
                            <div style={{ position: 'relative' }}>
                             <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="SEARCH CLIENT BY NAME OR ID NUMBER*" onChange={handleSearch}>
                                <Form.Control  className='inputSearch' value={searchTerm}  type="text" placeholder="Search by First or Last Name or ID number" />
                                {suggestions.length > 0 && (
                                    <ul
                                    style={{
                                        position: 'absolute',
                                        top: '100%',
                                        left: 0,
                                        right: 0,
                                        zIndex: 1000,
                                        listStyle: 'none',
                                        padding: 0,
                                        margin: 0,
                                        backgroundColor: 'white',
                                        border: '1px solid #ccc',
                                        maxHeight: '200px',
                                        overflowY: 'auto',
                                    }}
                                    >
                                    {suggestions.map((client) => (
                                        <li
                                        key={client.OID}
                                        onClick={() => handleSelect(client)}
                                        style={{
                                            padding: '8px',
                                            cursor: 'pointer',
                                            borderBottom: '1px solid #eee',
                                        }}
                                        onMouseEnter={(e) => {
                                            e.target.style.backgroundColor = '#f0f0f0';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.target.style.backgroundColor = 'white';
                                        }}
                                        >
                                        {client.FirstName} {client.Surname}-{client.IdentificationNo}
                                        </li>
                                    ))}
                                    </ul>
                                )}
                               
                             
                                
                            </FloatingLabel>

                            </div>

                                <p className="newClient" onClick={toggle} style={{width:'20%'}}>NEW CLIENT</p>
                                <div className="entryRow2">
                                    <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Commencemence date*" onChange={handleDateChange}>
                                        <Form.Control  className='inputSearch'   type="datetime-local" placeholder="Commcencement date" value={cm} />
                                    </FloatingLabel>
                                    
                                    <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Expiry date*" disabled>
                                        <Form.Control  className='inputSearch'   type="text" value={ex} placeholder="Expiry Date" />
                                    </FloatingLabel>
                                </div>
                                <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="VEHICLE REGISTRATION*" onChange={(e)=>{setReg(e.target.value)}}>
                                    <Form.Control  className='inputSearch' value={reg}  type="text" placeholder="VEHICLE REGISTRATION" />
                                </FloatingLabel>

                               
                            <div style={{ position: 'relative' }}>
                             <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="SEARCH VEHICLE MAKE*" onChange={handleSearch2}>
                                <Form.Control  className='inputSearch' value={searchTerm2}  type="text" placeholder="SEARCH VEHICLE MAKE*" />
                                {suggestions2.length > 0 && (
                                    <ul
                                    style={{
                                        position: 'absolute',
                                        top: '100%',
                                        left: 0,
                                        right: 0,
                                        zIndex: 1000,
                                        listStyle: 'none',
                                        padding: 0,
                                        margin: 0,
                                        backgroundColor: 'white',
                                        border: '1px solid #ccc',
                                        maxHeight: '200px',
                                        overflowY: 'auto',
                                    }}
                                    >
                                    {suggestions2.map((make) => (
                                        <li
                                        key={make.OID}
                                        onClick={() => handleSelect2(make)}
                                        style={{
                                            padding: '8px',
                                            cursor: 'pointer',
                                            borderBottom: '1px solid #eee',
                                        }}
                                        onMouseEnter={(e) => {
                                            e.target.style.backgroundColor = '#f0f0f0';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.target.style.backgroundColor = 'white';
                                        }}
                                        >
                                        {make.Description} 
                                        </li>
                                    ))}
                                    </ul>
                                )}
                               
                             
                                
                            </FloatingLabel>

                            </div>

                               
                            <div style={{ position: 'relative' }}>
                             <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="SEARCH VEHICLE MODEL*" onChange={handleSearch3}>
                                <Form.Control  className='inputSearch' value={searchTerm3}  type="text" placeholder="SEARCH VEHICLE MODEL*" />
                                {suggestions3.length > 0 && (
                                    <ul
                                    style={{
                                        position: 'absolute',
                                        top: '100%',
                                        left: 0,
                                        right: 0,
                                        zIndex: 1000,
                                        listStyle: 'none',
                                        padding: 0,
                                        margin: 0,
                                        backgroundColor: 'white',
                                        border: '1px solid #ccc',
                                        maxHeight: '200px',
                                        overflowY: 'auto',
                                    }}
                                    >
                                    {suggestions3.map((model) => (
                                        <li
                                        key={model.OID}
                                        onClick={() => handleSelect3(model)}
                                        style={{
                                            padding: '8px',
                                            cursor: 'pointer',
                                            borderBottom: '1px solid #eee',
                                        }}
                                        onMouseEnter={(e) => {
                                            e.target.style.backgroundColor = '#f0f0f0';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.target.style.backgroundColor = 'white';
                                        }}
                                        >
                                        {model.Description} 
                                        </li>
                                    ))}
                                    </ul>
                                )}
                               
                             
                                
                            </FloatingLabel>

                            </div>

                                <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="CHASSIS NUMBER*" onChange={(e)=>{setChassis(e.target.value)}}>
                                    <Form.Control  className='inputSearch' value={chassis}  type="text" placeholder="CHASSIS NUMBER" />
                                </FloatingLabel>
                              
                                    {doubleInsurancestatus == true &&
                                    <p style={{color:'red'}}>{doubleinsuranceMessage}</p>
                                    }
                                     {doubleInsurancestatus == false &&
                                    <p style={{color:'green'}}>{doubleinsuranceMessage}</p>
                                    }
                            
                                {checking ==2 &&
                                    <p>Checking double insurance... </p>
                                }
                                <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="ENGINE NUMBER" onChange={(e)=>{setEnginenumber(e.target.value)}}>
                                    <Form.Control  className='inputSearch' value={engineNumber}  type="text" placeholder="ENGINE NUMBER" />
                                </FloatingLabel>
                                <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="ENGINE RATING" onChange={(e)=>{setCC(e.target.value)}}>
                                    <Form.Control  className='inputSearch' value={cc}  type="text" placeholder="ENGINE RATING" />
                                </FloatingLabel>
                                <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="COLOR" onChange={(e)=>{setColor(e.target.value)}}>
                                    <Form.Control  className='inputSearch' value={color}  type="text" placeholder="COLOR" />
                                </FloatingLabel>
                                <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="YEAR OF MANUFACTURE*" onChange={(e)=>{setYom(e.target.value)}}>
                                    <Form.Control  className='inputSearch' value={yom}  type="number" placeholder="YEAR OF MANUFACTURE" />
                                </FloatingLabel>
                                <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="LOG BOOK OR PREVIOUS CERTIFICATE" onChange={handleFileChange}>
                                    <Form.Control  className='inputSearch' type="file" placeholder="LOG BOOK OR PREVIOUS CERTIFICATE" />
                                </FloatingLabel>

                                <div className="stepButtons">
                                    <Button color="danger" className="quoteButton" onClick={()=>{setStep(2)}}>PREVIOUS STEP</Button>
                                    <Button color="success" className="quoteButton" onClick={makePayment}>MAKE PAYMENT</Button>
                                </div>

                        </div>
                    
                    
                    }
                        {step !== 1 &&
                              <div className="coverBanner">
                            <img src="/entry.jpg" className="entryImage" alt="" />
                        </div>
                        }
                      
                       </div>


                   
                    
                   
                    </CardBody>
                </Card>
        </div>

        <Modal isOpen={modal6} toggle={calculate} size="md">

            <ModalHeader>New Cover</ModalHeader>
            <div className="modalContainer1">

                        <div className="coverEntry1s">
                            
                            <div className="entryField">
                            {/* <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="SELECT PRODUCT" onChange={(e)=>{setProductcode(e.target.value)}}>
                                <Form.Select className='inputSearch'>
                                    <option selected disabled>SELECT PRODUCT</option>
                                  
                                        <>
                                        {products.map((val)=>{
                                        return(
                                            <option key={val.OID} value={val.OID}>{val.ProductDescription}-{val.OID}</option>
                                        )
                                        })}
                                        </>      
                                </Form.Select>
                            </FloatingLabel>
                            */}
                            <p>Product code: {productCode}</p>
                            <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="SELECT COVER OPTION" onChange={(e)=>{setCoveroptioncode(e.target.value)}}>
                                <Form.Select className='inputSearch'>
                                    <option selected disabled>SELECT COVER OPTION</option>
                                   
                                    {coverOptions.map((val)=>{
                                            return(
                                                 <option key={val.OID} value={val.OID}>{val.OptionName}</option>
                                            )
                                           
                                      
                                       
                                    })}
                                     {/* {coverOptions.map((val)=>{
                                        if(val.OptionName !== 'COMP' && val.OptionName !== 'Comp'){
                                             return(
                                            <option key={val.OID} value={val.OID}>{val.OptionName}</option>
                                        )
                                        }
                                       
                                    })} */}
                                </Form.Select>
                            </FloatingLabel>
                            
                          
                            {/* <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="SELECT INSURED ITEM" >
                                <Form.Select className='inputSearch'>
                                   <option key={val.OID} value={val.OID}>{val.ItemName}</option>
                                    {insuredItems.map((val)=>{
                                        return(
                                            <option key={val.OID} value={val.OID}>{val.ItemName}</option>
                                        )
                                    })}
                                </Form.Select>
                            </FloatingLabel> */}
                          
                            {(coverOption == 1 || coverOption==58) &&
                                <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="SUM INSURED" onChange={(e)=>{setSuminsured(e.target.value)}}>
                                    <Form.Control  className='inputSearch' value={sumInsured}  type="number" placeholder="SUM INSURED" />
                                </FloatingLabel>
                            
                            }

                         
                                <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="SEATING CAPACITY" onChange={(e)=>{setCapacity(e.target.value)}}>
                                    <Form.Control  className='inputSearch' value={capacity}  type="number" placeholder="SEATING CAPACITY" />
                                </FloatingLabel>
                            
                            
                          


                            
                            

                            {(productCode == 3531 || productCode == 3588 || productCode == 4688 || productCode == 4695 || productCode ==3604 || productCode == 4630 || productCode == 3592 ) &&
                            
                                <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Tonnage(Load Capacity)" onChange={(e)=>{setTonnage(e.target.value)}}>
                                    <Form.Control  className='inputSearch' value={tonnage}  type="text" placeholder="Tonnage(Load Capacity)" />
                                </FloatingLabel>
                            }
                              
                            <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="PAYMENT INTERVAL" onChange={(e)=>{setCoverperiod(e.target.value)}}>
                                <Form.Select className='inputSearch'>
                                    <option selected disabled>Number of Installments</option>
                                    {((productCode==4638 && coverOption == 2)  || (productCode == 3587 && coverOption == 2)) &&
                                        <>
                                            <option value="Week">7 Days</option>
                                            <option value="Fortnight">14 Days</option>
                                            <option value="Monthly">30 Days</option>
                                            <option value="Annually">Annual</option>
                                            <option value="3Installments">3 Installments</option>
                                            <option value="6Installments">6 Installments</option>
                                            <option value="10Installments">10 Installments</option>
                                        </>
                                    
                                    }
                                    
                                    {((productCode != 4638 && coverOption == 2) && (productCode != 3587 && coverOption == 2)) &&
                                      
                                        <>
                                         {(productCode != 4695 && productCode != 4694) &&
                                            <>
                                                <option value="Annually">Annual</option>
                                                <option value="2installments">2 Installments</option>
                                            </>
                                         
                                         }
                                           
                                        </>

                                    }
                                     {((productCode!==4638 && coverOption==1) && (productCode !==3587 && coverOption == 1)) &&

                                     <>
                                        <option value="Monthly">30 Days</option>
                                        <option value="3installments">3 Installments</option>
                                     </>

                                    }
                                    {((productCode!==4638 && coverOption==58) && (productCode !==3587 && coverOption == 58)) &&
                                                                           <>
                                         <option value="Monthly">30 Days</option>
                                        <option value="3installments">3 Installments</option>
                                     </>
                                    }

                                    {(productCode == 4695 || productCode == 4694) &&
                                         <option value="Monthly">30 Days</option>
                                    }
                                    
                                </Form.Select>
                            </FloatingLabel>

                            <Button color="success" className="quoteButton" onClick={getQuote}>{quoteText}</Button>


                            </div>

                            
                        </div>

            </div>
        </Modal>

        <Modal isOpen={modal} toggle={toggle} size="lg">
            <ModalHeader>NEW CLIENT</ModalHeader>
            <div className="modalContainer">
                <div className="entryRow2">
                <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="FIRST NAME*" onChange={(e)=>{setFirstname(e.target.value)}}>
                    <Form.Control  className='inputSearch' value={firstName}  type="text" placeholder="FIRST NAME" />
                </FloatingLabel>

                <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="LAST NAME*" onChange={(e)=>{setLastname(e.target.value)}}>
                    <Form.Control  className='inputSearch' value={lastName}  type="text" placeholder="LAST NAME" />
                </FloatingLabel>

                <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="OTHER NAMES" onChange={(e)=>{setOthernames(e.target.value)}}>
                    <Form.Control  className='inputSearch' value={otherNames}  type="text" placeholder="OTHER NAMES" />
                </FloatingLabel>

                </div>

                <div className="entryRow2">
                <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="PHONE NUMBER*" onChange={(e)=>{setPhone(e.target.value)}}>
                    <Form.Control  className='inputSearch' value={phone}  type="text" placeholder="PHONE NUMBER" />
                </FloatingLabel>

                <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="EMAIL ADDRESS*" onChange={(e)=>{setEmail(e.target.value)}}>
                    <Form.Control  className='inputSearch' value={email}  type="text" placeholder="EMAIL ADDRESS" />
                </FloatingLabel>

                <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="IDENTIFICATION NUMBER*" onChange={(e)=>{setIDNumber(e.target.value)}}>
                    <Form.Control  className='inputSearch' value={idNumber}  type="text" placeholder="IDENTIFICATION NUMBER" />
                </FloatingLabel>

                </div>
                <FloatingLabel className='formInput3' controlId="floatingInputGrid" label="KRA PIN*" onChange={(e)=>{setPin(e.target.value)}}>
                    <Form.Control  className='inputSearch' value={pin}  type="text" placeholder="KRA PIN" />
                </FloatingLabel>
                <p>Required documents</p>
                <div className="uploadDocuments">
                    <div className="fileUpload">
                    <p>IDENTIFICATION*</p>
                    <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="IDENTIFICATION" onChange={handleFileChange1} >
                        <Form.Control  className='inputSearch' type="file" placeholder="IDENTIFICATION" />
                    </FloatingLabel>
                    </div>
                    <div className="fileUpload">
                    <p>KRA PIN*</p>
                    <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="KRA PIN" onChange={handleFileChange3} >
                        <Form.Control  className='inputSearch' type="file" placeholder="KRA PIN" />
                    </FloatingLabel>
                    </div>
                    <div className="fileUpload">
                    <p>ANY OTHER</p>
                    <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="ANY OTHER" onChange={handleFileChange2} >
                        <Form.Control  className='inputSearch' type="file" placeholder="ANY OTHER" />
                    </FloatingLabel>
                    </div>
                </div>

                <Button color="success" onClick={createClient}>{submitText}</Button>

            </div>
        </Modal>

        <Modal isOpen={modal2}>
            <ModalHeader>MAKE PAYMENT</ModalHeader>
            <div className="modalContainer">

                {isCert == 0 &&
                
                <>
                 {/* <div>
                <label>
                    <input
                    type="radio"
                    value="GROSS"
                    checked={selectedOption === 'GROSS'}
                    onChange={handleOptionChange}
                    style={{marginRight:'5px'}}
                    />
                    GROSS PAYMENT
                </label>

                <label style={{marginLeft:'10px'}}>
                    <input
                    type="radio"
                    value="NET"
                    checked={selectedOption === 'NET'}
                    onChange={handleOptionChange}
                    style={{marginRight:'5px'}}
                    />
                    NET PAYMENT
                </label>

                
                </div> */}

               
                <hr />
                <h6>Amount to pay: Kes. {formatter(payAmount)}</h6>
                <hr />
                <div className="checkboxes">
                <label className="checkboxLabel1">
                    <input 
                    type="checkbox" 
                    checked={paymentMode === 1}
                    onChange={handleChange}
                    style={{marginRight:'3px'}}
                    />
                    PAY FROM WALLET
                </label>


                {/* <label className="checkboxLabel2">
                    <input 
                    type="checkbox" 
                    checked={utilize === 1}
                    onChange={handleChange2}
                    style={{marginRight:'3px'}}
                    />
                    UTILIZE COMMISSION
                </label> */}

                </div>
               

                    {isMpesa &&
                        <FloatingLabel 
                        className='formInput2' 
                        controlId="floatingInputGrid" 
                        label="MPESA NUMBER*"
                        onChange={(e) => setMpesaphone(e.target.value)}
                    >
                        <Form.Control 
                            className='inputSearch' 
                            value={mpesaPhone} 
                            type="text" 
                            placeholder="MPESA NUMBER" 
                        />
                    </FloatingLabel>
                    
                    }
     
                    
             
                {paymentMode == 1 &&
                    <p>AVAILABLE BALANCE: KES. {walletBallance}</p>
 
                }
                {utilize == 1 &&
                    <p>AVAILABLE COMMISSION: KES. {availableCommission}</p>
 
                }

                
               



               
                {promptID == 0 &&
                     <Button color="success" className="quoteButton2" onClick={createProposal} >{payTest}</Button>
                
                }
                {promptID == 1 &&
                     <Button color="success" className="quoteButton2" onClick={resendRequest} >{resendText}</Button>
                
                }
               

                {/* {(isMpesa && !prompt) &&
                
                <>
                  <p style={{textAlign:'center',marginTop:'4%',marginBottom:'2%'}}>___________OR__________</p>
                <div className="mpesaSteps">
                    <p>1. GO TO  MPESA TOOLKIT</p>
                    <p>2. SELECT LIPA NA MPESA</p>
                    <p>3. SELECT PAYBILL</p>
                    <p>4. ENTER PAYBILL NUMBER <strong>200300</strong></p>
                    <p>5. ENTER ACCOUNT <strong>{reg}</strong></p>
                    <p>6. ENTER MPESA PIN AND COMPLETE</p>
                    
                     <p onClick={openModule3} style={{fontSize:'17px',marginTop:'5%',fontWeight:'bold',color:'#0f4f48',cursor:"pointer "}}>ALREADY PAID? CLICK HERE</p>
                    
                   
                </div>
                
                </>
                
                } */}
               
              
                
                </>
                
                
                }
                {isCert == 1 &&
                <>
                    <a style={{backgroundColor:'green',width:'100%',color:'white',padding:'10px',borderRadius:'5px',marginBottom:'20px'}} href={certURL} target="_blank" rel="noreferrer">DONWLOAD CERTIFICATE</a>
                    <p style={{marginTop:'15px'}}>DISCLAIMER: If Certificate does not download, click the 'DOWNLOAD BUTTON' again!</p>
                   
                    <hr />
                </>
                
                
                }
                {isCert == 2 &&
                <>
                    <p style={{color:'red'}}>ERROR: {errorMessage}</p>
                    <Button color="success" onClick={retryCertficate}>{retryText}</Button>
                </>
                
                }
           
                <div className="">
                    <p style={{color:'green',marginTop:'5%',float:'left',cursor:'pointer'}} onClick={finish}>FINISH</p>
                </div>
                
                {isCert == 0 &&
                
                    <p style={{color:'red',marginTop:'5%',float:'right',cursor:'pointer'}} onClick={close2}>BACK</p>
                }
              
            </div>
        </Modal>
        <Modal isOpen={modal3}>
            <ModalHeader>Confirm Payment</ModalHeader>
            <div className="modalContainer">
                {!checkMpesa &&
                    <p style={{textAlign:'center'}}>Checking payment please wait...</p>
                }
                {checkMpesa &&
                    <>
                        <p style={{color:'red'}}>Kindly enter the transaction code below</p>
                        <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Transaction code" onChange={(e)=>{setMpesacode(e.target.value)}} >
                            <Form.Control  className='inputSearch' type="text" placeholder="Transaction code" />
                        </FloatingLabel>
                        <Button color="success" onClick={checkMpesatransaction}>{verifyText}</Button>
                       
                    </>
                
                }
                 <p style={{color:'red',marginTop:'5%',float:'right',cursor:'pointer'}} onClick={close3}>CLOSE</p>
            </div>
        </Modal>
    </div>
  )
}

